import { IClip } from '../../../api/Data'
import VideoImagePlaceholder from '../../../_images/video-upload-placeholder.jpg'

export const getOverviewClipImage = (clip: IClip) =>
  clip.encodingStatus === 'encoding'
    ? clip.processingPosterUrl || clip.imageLowResUrl || VideoImagePlaceholder
    : clip.imageLowResUrl || clip.processingPosterUrl || VideoImagePlaceholder

export const replaceBrokenOverviewClipImage = (image: Pick<HTMLImageElement, 'src'>) => {
  if (image.src !== VideoImagePlaceholder) image.src = VideoImagePlaceholder
}
